import React from 'react';
import { Link } from 'react-router-dom';
import { FiCheck, FiInfo, FiCreditCard } from 'react-icons/fi';
import { FaWhatsapp } from 'react-icons/fa';
import SafeIcon from '../common/SafeIcon';

const ProductCard = ({ product, currency = 'MXN' }) => {
  const isMxn = currency === 'MXN';
  const displayPrice = isMxn ? product.priceMxn : product.priceUsd;
  const whatsappNumber = "529844594738";
  const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(`Hola! Me interesa el programa: ${product.title}. ¿Me pueden dar más información?`)}`;

  const getGradient = (level) => {
    switch(level) {
      case 'LEGENDARY': case 'ELITE': return 'from-yellow-600/20 to-yellow-900/10 border-yellow-500/50';
      case 'MÁS POPULAR': case 'RECOMENDADO': return 'from-green-600/20 to-green-900/10 border-green-500/50';
      default: return 'from-zinc-800 to-zinc-900 border-zinc-700';
    }
  };

  return (
    <div className={`rounded-3xl p-8 border transition-all group flex flex-col h-full relative overflow-hidden bg-gradient-to-br ${getGradient(product.level)} hover:scale-[1.02] hover:shadow-2xl`}>
      <div className="absolute top-0 right-0 px-4 py-1 rounded-bl-xl text-[10px] font-black uppercase tracking-widest bg-zinc-800 text-white">
        {product.level}
      </div>
      
      <div className="flex items-start justify-between mb-6 pt-2">
        <div className="w-14 h-14 bg-black/50 rounded-2xl flex items-center justify-center text-white border border-white/10">
          <SafeIcon icon={product.icon} className="text-3xl" />
        </div>
        <div className="text-[10px] font-black text-green-400 uppercase tracking-widest bg-green-900/20 px-2 py-1 rounded">
          {product.xp}
        </div>
      </div>

      <h3 className="text-2xl font-black text-white mb-2 uppercase italic tracking-tighter">
        {product.title}
      </h3>
      <p className="text-gray-400 text-sm mb-6 line-clamp-2">{product.description}</p>

      <div className="flex items-baseline gap-2 mb-8">
        <span className="text-4xl font-black text-white">
          {displayPrice === 0 ? 'GRATIS' : `$${displayPrice.toLocaleString()}`}
        </span>
        <span className="text-sm font-bold text-gray-500 uppercase">{currency}</span>
      </div>

      <div className="space-y-3 mb-8 flex-1">
        {product.features.map((feat, i) => (
          <div key={i} className="flex items-start gap-2 text-sm text-gray-300">
            <SafeIcon icon={FiCheck} className="text-green-500 mt-1 shrink-0" />
            <span>{feat}</span>
          </div>
        ))}
      </div>

      <div className="space-y-3">
        {product.stripeUrl && (
          <a href={product.stripeUrl} target="_blank" rel="noreferrer" className="w-full bg-indigo-600 text-white py-4 rounded-xl font-black uppercase text-xs flex items-center justify-center gap-2 hover:bg-indigo-500 transition-all shadow-lg border border-indigo-400/30">
            <SafeIcon icon={FiCreditCard} className="text-lg" /> Pagar con Tarjeta
          </a>
        )}
        <a href={whatsappUrl} target="_blank" rel="noreferrer" className="w-full bg-green-700 text-white py-3 rounded-xl font-black uppercase text-[10px] flex items-center justify-center gap-2 hover:bg-green-600 transition-all">
          <SafeIcon icon={FaWhatsapp} className="text-base" /> Shop on WhatsApp
        </a>
        <Link to={`/p/${product.slug}`} className="w-full bg-zinc-800 border border-zinc-700 text-white py-3 rounded-xl font-bold text-[10px] flex items-center justify-center gap-2 hover:bg-zinc-700 transition-colors uppercase">
          <SafeIcon icon={FiInfo} /> Ver Detalles
        </Link>
      </div>
    </div>
  );
};

export default ProductCard;